import { createBrowserRouter } from 'react-router-dom';
import App from '../App.jsx';
import ChatPreset from "../pages/Chat/ChatPreset.jsx";
import Login from "../pages/Login/Login.jsx";
import Test from "../pages/Test/Test.jsx";
const routes = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { path: 'chat', element: <ChatPreset /> },
      { path: 'test', element: <Test /> },
    ]
  },
  {
    path: '/login',
    element: <Login />,
  },

])

export default routes;
